import type { Locale } from '@change-corgi/config/locales';

export const OG_IMAGE = 'https://static.change.org/brand-pages/impact/opengraph-impact.jpg';

export const BG_IMPACT_GRID_IMAGE = 'https://static.change.org/brand-pages/impact/Impact-grid-720.jpg';

export const TAKE_ACTION_IMG_URLS = [
	{ url: 'https://assets.change.org/photos/0/yy/zc/gWYYzCYDQyKGmrE-400x400-noPad.jpg?1515620392', desktopOnly: false },
	{ url: 'https://assets.change.org/photos/6/th/va/vlthvAdgSBLJPbs-400x400-noPad.jpg?1516866413', desktopOnly: false },
	{ url: 'https://assets.change.org/photos/8/oj/zm/bdojZMUCvzxRSSN-400x400-noPad.jpg?1515937258', desktopOnly: false },
	{ url: 'https://assets.change.org/photos/5/rm/sw/fqRMSWIetwCbMdr-400x400-noPad.jpg?1529531543', desktopOnly: false },
	{ url: 'https://assets.change.org/photos/0/dd/jy/moddjygCUsqZeUU-400x400-noPad.jpg?1527833572', desktopOnly: false },
	{ url: 'https://assets.change.org/photos/9/vc/mo/mZVcmOgOGUpHrOK-400x400-noPad.jpg?1549338689', desktopOnly: true },
	{ url: 'https://assets.change.org/photos/1/to/vq/xQtovqHuVIqhqRI-400x400-noPad.jpg?1518110273', desktopOnly: true },
	{ url: 'https://assets.change.org/photos/4/uh/hh/SyuHHHqdVsyVKmH-400x400-noPad.jpg?1526415237', desktopOnly: true },
	{ url: 'https://assets.change.org/photos/7/nm/uu/annMUUrTrNFbZop-400x400-noPad.jpg?1525655156', desktopOnly: true },
	{ url: 'https://assets.change.org/photos/3/ty/qd/kVTyqDrStkbfcet-400x400-noPad.jpg?1492701055', desktopOnly: true },
	{ url: 'https://assets.change.org/photos/3/xm/iw/mJXMiwwezzDlWpy-400x400-noPad.jpg?1491589145', desktopOnly: true },
	{ url: 'https://assets.change.org/photos/4/sa/ro/TxsaROVUlPAGtWc-400x400-noPad.jpg?1517907141', desktopOnly: true },
	{ url: 'https://assets.change.org/photos/5/jc/dp/UFJcdpSiDUzVeMG-400x400-noPad.jpg?1537204801', desktopOnly: true },
];

export const MEMBERSHIP_COUNTRY_CONFIG: Record<string, { imageUrl?: string }> = {
	default: {
		imageUrl: 'https://static.change.org/brand-pages/subscriptions/us/protesters.png',
	},
	AU: {
		imageUrl: 'https://static.change.org/brand-pages/subscriptions/au/protesters.png',
	},
	GB: {
		imageUrl: 'https://static.change.org/brand-pages/subscriptions/gb/protesters.png',
	},
	ES: {
		imageUrl: 'https://static.change.org/brand-pages/subscriptions/es/protesters.png',
	},
	FR: {
		imageUrl: 'https://static.change.org/brand-pages/subscriptions/fr/protesters.png',
	},
	IT: {
		imageUrl: 'https://static.change.org/brand-pages/subscriptions/it/protesters.png',
	},
	RU: {
		imageUrl: undefined,
	},
	AR: {
		imageUrl: 'https://static.change.org/brand-pages/subscriptions/ar/protesters.png',
	},
	CO: {
		imageUrl: 'https://static.change.org/brand-pages/subscriptions/co/protesters.png',
	},
	JP: {
		imageUrl: 'https://static.change.org/brand-pages/subscriptions/jp/protesters.png',
	},
};

export const VIDEO_EMBED_IDS: Partial<Record<Locale, string>> & { default: string } = {
	'es-ES': 'U1LFGelN2aY',
	'es-419': 'U1LFGelN2aY',
	'es-AR': 'U1LFGelN2aY',
	'fr-FR': 'SZgKJXoscRU',
	default: 'UcT1rgZDko4',
};

export const ccLocaleMap: Partial<Record<Locale, string>> = {
	'en-US': 'en',
	'en-IN': 'en',
	'en-GB': 'en',
	'en-CA': 'en',
	'en-AU': 'en',
	'es-ES': 'es',
	'es-AR': 'es-mx',
	'fr-FR': 'fr',
	'de-DE': 'de',
	'id-ID': 'id',
	'ko-KR': 'ko',
	'ja-JP': 'ja',
	'it-IT': 'it',
	'ru-RU': 'ru',
	'es-419': 'es-mx',
	'th-TH': 'th',
	'tr-TR': 'tr',
	'pt-BR': 'pt-br',
};
